<template>
  <BaseAlert v-if="notification" data-automation="notification" role="alert" :type="notification.type" class="flex items-center mb-5">
    <Component :is="notification.type === 'success' ? 'CheckCircleIcon' : 'InformationCircleIcon'" class="hidden sm:block w-6 h-6 mr-4 m-0 shrink-0" />
    {{ notification.message }}
  </BaseAlert>
</template>

<script>
import { mapState } from 'vuex';
import BaseAlert from '@/components/BaseAlert.vue';
import CheckCircleIcon from '@/components/Icons/CheckCircleIcon.vue';
import InformationCircleIcon from '@/components/Icons/InformationCircleIcon.vue';

export default {
  name: 'AppNotification',
  components: {
    BaseAlert,
    CheckCircleIcon,
    InformationCircleIcon
  },
  computed: {
    ...mapState({
      notification: state => state.notifications.notification
    })
  }
}
</script>
